import FormItem from "@components/FormItem/FormItem";
import FormSection from "@components/FormSection/FormSection";
import {
  FORM_FIELDS,
  TEST_ID_BASE,
  type PreNominationRequestFormData,
  type PreNominationRequestLabels,
} from "../constants";
import PreNominationRequestDocumentUpload from "./PreNominationRequestDocumentUpload";

interface PreNominationRequestAttachmentsSectionProps {
  labels: PreNominationRequestLabels;
  documentsTitle: string;
  updateFormData: <K extends keyof PreNominationRequestFormData>(
    key: K,
    value: PreNominationRequestFormData[K],
  ) => void;
}

const PreNominationRequestAttachmentsSection = ({
  labels,
  documentsTitle,
  updateFormData,
}: PreNominationRequestAttachmentsSectionProps) => (
  <>
    <FormItem<PreNominationRequestFormData, typeof FORM_FIELDS.REMARKS>
      name={FORM_FIELDS.REMARKS}
      type="textarea"
      minRows={3}
      maxChars={1000}
      showCharCounter
      label={labels.remarks}
      onFieldChange={updateFormData}
      testId={`${TEST_ID_BASE}-remarks`}
    />

    <FormSection isFullWidth title={documentsTitle}>
      <PreNominationRequestDocumentUpload updateFormData={updateFormData} />
    </FormSection>
  </>
);

export default PreNominationRequestAttachmentsSection;
